import React from "react";
import { css } from "@emotion/core";
import { Tablet, Desktop } from "../../constants/responsive";
import { AdvisoryFeeCard, StockTradingFeeCard } from "./FeeCard";
import { useIntl, FormattedMessage } from "gatsby-plugin-intl";
import FeeDetailCards from "./FeeDetailCard";

// 【股票组合的收费】
const AnnualAdvisoryFees2 = ({ show = true }) => {
  const intl = useIntl();
  const data = [
    {
      column1: "<$100K",
      column2: "0.8%",
      column3: "0%",
    },
    {
      column1: "$100K-$500K",
      column2: "0.7%",
      column3: "0%",
    },
    {
      column1: "$500K-$1M",
      column2: "0.6%",
      column3: "0%",
    },
    {
      column1: "$1M-$3M",
      column2: "0.5%",
      column3: "0%",
    },
    {
      column1: ">$3M",
      column2: "0.5%",
      column3: "0%",
    },
  ];

  const tableTitleCss = css`
    padding-left: 16px;
    width: 200px;
    min-height: 48px;
    display: flex;
    align-items: center;
    font-size: 18px;
    text-align: left;
    ${Tablet} {
      width: 280px;
      min-height: 48px;
      height: fit-content;
    }
    ${Desktop} {
      width: 33.33%;
      min-height: 48px;
    }
  `;

  return (
    <div
      css={css`
        display: ${show ? "flex" : "none"};
        width: 100%;
        justify-content: center;
        border-radius: 8px;
        border: 1px solid #e6e7eb;
        overflow: auto;
        ${Tablet} {
          width: auto;
        }
        ${Desktop} {
          width: 100%;
        }
      `}
    >
      <div
        css={css`
          overflow: hidden;
          width: auto;
          ${Tablet} {
            width: auto;
          }
          ${Desktop} {
            width: 100%;
          }
        `}
      >
        <div css={css``}>
          <div
            css={css`
              display: flex;
              min-height: 48px;
              color: #69758a;
              border-bottom: 1px solid #e6e7eb;
              background-color: #edf2f7;
            `}
          >
            <div css={tableTitleCss}>
              {intl.formatMessage({ id: "fee.annual.portfolio value" })}
            </div>
            <div css={tableTitleCss}>
              {intl.formatMessage({ id: "fee.annual.asset allocation" })}
            </div>
            <div css={tableTitleCss}>
              {intl.formatMessage({
                id: "fee.annual.cash management portfolios",
              })}
            </div>
          </div>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
          `}
        >
          {data.map((item, index) => {
            const cssStr = css`
              padding-left: 16px;
              text-align: left;
              width: 200px;
              font-size: 18px;
              font-weight: 500;
              ${Tablet} {
                width: 280px;
                font-size: 20px;
              }
              ${Desktop} {
                width: 33.33%;
                font-size: 22px;
              }
            `;
            return (
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  height: 70px;
                  background-color: ${index % 2 === 0 ? "#fff" : "#F9FAFB"};
                  border-bottom: 1px solid #e6e7eb;
                `}
                key={item.column1}
              >
                <div css={cssStr}>{item.column1}</div>
                <div css={cssStr}>{item.column2}</div>
                <div css={cssStr}>{item.column3}</div>
              </div>
            );
          })}
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            height: 48px;
            width: 100%;
            font-size: 12px;
            font-weight: 500;
            color: #69758a;
            padding-left: 16px;
          `}
        >
          {intl.formatMessage({
            id: "fee.advised-portfolios.annual.bottom-note",
          })}
        </div>
      </div>
    </div>
  );
};

// 【年华咨询费】
const ActivePortfoliosAnnualFee = ({ show = true }) => {
  const intl = useIntl();
  const data = [
    {
      column1: "<$500K",
      column2: "1.0%",
    },
    {
      column1: "$500K-$1M",
      column2: "0.9%",
    },
    {
      column1: "$1M-$3M",
      column2: "0.8%",
    },
    {
      column1: ">$3M",
      column2: "0.7%",
    },
  ];

  const tableTitleCss = css`
    padding-left: 16px;
    width: 50%;
    height: 48px;
    display: flex;
    align-items: center;
    font-size: 18px;
  `;

  return (
    <div
      css={css`
        display: ${show ? "flex" : "none"};
        width: 100%;
        justify-content: center;
        border-radius: 8px;
        border: 1px solid #e6e7eb;
        overflow: auto;
        ${Tablet} {
          width: 100%;
        }
        ${Desktop} {
          width: 100%;
        }
      `}
    >
      <div
        css={css`
          overflow: hidden;
          width: 100%;
        `}
      >
        <div
          css={css`
            width: 100%;
          `}
        >
          <div
            css={css`
              display: flex;
              height: 48px;
              color: #69758a;
              border-bottom: 1px solid #e6e7eb;
              background-color: #edf2f7;
              width: 100%;
            `}
          >
            <div css={tableTitleCss}>
              {intl.formatMessage({ id: "fee.annual.portfolio value" })}
            </div>
            <div css={tableTitleCss}>
              {intl.formatMessage({ id: "fee.annual.title" })}
            </div>
          </div>
        </div>
        <div
          css={css`
            display: flex;
            flex-direction: column;
            width: 100%;
          `}
        >
          {data.map((item, index) => {
            const cssStr = css`
              padding-left: 16px;
              text-align: left;
              width: 50%;
              font-size: 18px;
              font-weight: 500;
              ${Tablet} {
                font-size: 20px;
              }
              ${Desktop} {
                font-size: 22px;
              }
            `;
            return (
              <div
                css={css`
                  display: flex;
                  align-items: center;
                  height: 70px;
                  background-color: ${index % 2 === 0 ? "#fff" : "#F9FAFB"};
                  border-bottom: 1px solid #e6e7eb;
                `}
                key={item.column1}
              >
                <div css={cssStr}>{item.column1}</div>
                <div css={cssStr}>{item.column2}</div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

// 【股票组合的收费】
const AnnualAdvisoryFees = ({ show = true }) => {
  return (
    <div
      css={css`
        display: ${show ? "flex" : "none"};
        width: 100%;
        justify-content: center;
        ${Tablet} {
          width: auto;
        }
        ${Desktop} {
          width: 100%;
        }
      `}
    >
      {/* PC端布局：一行4个Card */}
      <div
        css={css`
          display: none;

          ${Tablet} {
            display: none;
          }
          ${Desktop} {
            width: 100%;
            display: flex;
            justify-content: space-between;
            margin-bottom: 12px;
          }
        `}
      >
        <AdvisoryFeeCard id="1" />
        <AdvisoryFeeCard id="2" />
        <AdvisoryFeeCard id="3" />
        <AdvisoryFeeCard id="4" />
      </div>
      {/* ipad与手机端布局：两行各2个Card */}
      <div
        css={css`
          margin-bottom: 14px;
          ${Tablet} {
            margin-bottom: 14px;
          }
          ${Desktop} {
            display: none;
          }
        `}
      >
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            max-width: 333px; //当手机宽度足够时，限制该行最大宽度，防止两Card间隔过大。
            margin-bottom: 14px;
            ${Tablet} {
              width: 481px;
              max-width: 481px; //因为上面定义的max-width会对ipad端有影响，故定义。
              margin-bottom: 18px;
            }
          `}
        >
          <AdvisoryFeeCard id="1" />
          {/* 当手机宽度过小时，保持最小间隔，使Card组件宽度适应变化 */}
          <div
            css={css`
              width: 11px;
              ${Tablet} {
                display: none;
              }
            `}
          ></div>
          <AdvisoryFeeCard id="2" />
        </div>
        <div
          css={css`
            display: flex;
            justify-content: space-between;
            width: 100%;
            max-width: 333px;
            ${Tablet} {
              width: 481px;
              max-width: 481px;
            }
          `}
        >
          <AdvisoryFeeCard id="3" />
          <div
            css={css`
              width: 11px;
              ${Tablet} {
                display: none;
              }
            `}
          ></div>
          <AdvisoryFeeCard id="4" />
        </div>
      </div>
    </div>
  );
};

// 【个股的收费】
const StockTradingFees = ({ show = true }) => {
  return (
    <div
      css={css`
        display: ${show ? "flex" : "none"};
        width: 100%;

        justify-content: center;
        ${Tablet} {
          width: auto;
        }
        ${Desktop} {
          width: 100%;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          width: 333.4px;

          ${Tablet} {
            width: 647.4px;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
          }
          ${Desktop} {
            width: 867.2px;
            display: flex;
            justify-content: space-between;
          }
        `}
      >
        <StockTradingFeeCard id="1" />
        <StockTradingFeeCard id="2" />
        <StockTradingFeeCard id="3" />
      </div>
    </div>
  );
};
export {
  AnnualAdvisoryFees,
  AnnualAdvisoryFees2,
  StockTradingFees,
  ActivePortfoliosAnnualFee,
  FeeDetailCards,
};
